"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SquareDecimeter = exports.SquareCentimeter = exports.SquareMillimeter = exports.SquareFeet = exports.SquareInch = exports.SquareMeter = void 0;
var uom_1 = require("uom");
var length_1 = require("./length");
var unit_squared_1 = require("../unit-squared");
/** The metric unit for area quantities ( <code>m²</code> ). */
exports.SquareMeter = unit_squared_1.Squared("SquareMeter", uom_1.BaseUnits.Meter);
/// Area
exports.SquareInch = unit_squared_1.Squared("SquareInch", length_1.Inch);
exports.SquareFeet = unit_squared_1.Squared("SquareFeet", length_1.Foot);
exports.SquareMillimeter = unit_squared_1.Squared("SquareMillimeter", length_1.Millimeter);
exports.SquareCentimeter = unit_squared_1.Squared("SquareCentimeter", length_1.CentiMeter);
exports.SquareDecimeter = unit_squared_1.Squared("SquareDecimeter", length_1.Decimeter);
//# sourceMappingURL=area.js.map